<template>
  <div class="GlobalFormDemo">
    <GlobalForm
      :init-data="initData"
      :form-rules="formRules"
      :form-item-list="formItemList"
      :inline="true"
      round
      :needBtnLoading="true"
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
      
      <el-form-item class="el_from" label="差价订单状态" slot="depreciateState" label-width="100px" style="margin:0">
        <el-select
          v-model="depreciateState"
          placeholder="请选择差价订单状态"
          clearable
        >
          <el-option
            v-for="item in stateOptions"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item class="el_from select_down" label="询价门店" slot="storeId" label-width="100px" style="margin:0">
        <el-select
          filterable
          :popper-append-to-body="false"
          v-model="storeId"
          placeholder="请选择询价门店"
          clearable
        >
          <el-option
            v-for="item in storeList"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="el_from" label="回收商家" slot="merchantId" label-width="100px" style="margin:0">
        <el-select
          v-model="merchantId"
          placeholder="请选择回收商家"
          clearable
        >
          <el-option
            v-for="item in recleStore"
            :key="item.merchantId"
            :label="item.merchantName"
            :value="item.merchantId"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="el_from" label="差价发起时间" slot="entryTime" label-width="100px" style="margin:0">
        <el-date-picker
          v-model='entryTime'
          type="daterange"
          start-placeholder="开始日期"
					range-separator="~"
          end-placeholder="结束日期"
					clearable
          @change="dateChange"
          :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
      
      <!-- <el-table-column label="筛选待处理差价订单" slot="recle" align="center">
        <template slot-scope="{ row }">
          <el-switch
            inactive-color="#bebebe"
            @change="handleSwitch(row)"
            v-model="isEnable"
          ></el-switch>
        </template>
      </el-table-column> -->
    </GlobalForm>

  </div>
</template>

<script>
import { formValidateMobile } from '@/utils/form-validate'
import moment from 'moment'
import _api from '@/utils/request'
export default {
  name: 'Form',
  data() {
    let _this = this
    return {
      typeId: '',
      depreciateState:'',
      merchantId:'',
      recleStore:[],
      storeList:[],
      storeId:"",
      stateOptions:[
         {
            key:'00',value:'待确认'
          },
          {
            key:'01',value:'已确认'
          },
          {
            key:'10',value:'已拒绝'
          }
      ],
      entryTime: null,
      initData: null,
      startTime: '',
      endTime: '',
      formItemList: [
        {
          key: 'orderNo',
          type: 'input',
          labelName: '订单编号',
          placeholder: '请输入订单编号',
        },
        {
          // labelName: '差价订单状态',
          slotName: 'depreciateState'
        },
        {
          key: 'phoneName',
          type: 'input',
          labelName: '回收商品',
          placeholder: '请输入商品名称',
        },
        {
          // labelName: '询价门店',
          slotName: 'storeId'
        },
        {
          // labelName: '订单状态',
          slotName: 'merchantId'
        },
        {
          key: 'recycleWay',
          type: 'select',
          labelName: '回收方式',
          width:85,
          placeholder: '请选择',
          option: [
            {
              value: '01',
              label: '以旧换新',
            },
            {
              value: '02',
              label: '仅回收',
            },
          ],
        },
        { slotName: 'entryTime' },
        {
          // labelName: '订单状态',
          slotName: 'recle'
        },
        /*********************************************** 更改位置 */
      ],
      formRules: {
        mobile: [
          {
            validator: formValidateMobile,
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {
    let startTime = moment().day(moment().day() - 14).format('YYYY-MM-DD 00:00:00') // 当前时间往前推一周的时间
    let endTime = moment().format('YYYY-MM-DD 23:59:59')
    this.entryTime = [startTime,endTime]
    // 回收商家下拉
    _api.getAllMiddleAdoptMerchant().then(res => {
        console.log(res)
        this.recleStore = res.data
    })
    this.getStoreList()
  },
  methods: {
    getStoreList(){
        _api.getStoreSelectOrder().then(res => {
          console.log(res,'1111111111111111111')
          this.storeList = res.data
      })
    },
    dateChange(e){
      console.log(this.entryTime);
    },
    //查询
    handleConfirm(data, cd) {
      console.log('提交了form', data)
      if (this.entryTime === null) {
        (this.startTime = ''), (this.endTime = '')
      } else {
        (this.startTime = moment(this.entryTime[0]).format("x")),
          (this.endTime = moment(this.entryTime[1]).format("x"))
      }
      const baseRequest = {
        businessType: data.businessType,
        typeId: data.typeId,
        merchantId: this.merchantId,
        recycleWay: data.recycleWay,
        storeId:this.storeId,
        orderNo: data.orderNo,
        phoneName: data.phoneName,
        depreciateState: this.depreciateState,
        endTime: this.endTime,
        startTime: this.startTime,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd()
          }
        },
      }
      console.log(baseRequest)
      this.$store.commit('tagsView/SEACH_PARAMS', baseRequest)
    },
  },
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
  .select_down{
    /deep/.el-popper{
      border-radius: 20px;
    }
    /deep/.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
      background-color: #E4ECFD;
      color: rgba(9, 129, 255, 1);
    }
  }
}
</style>
